import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "preview", "placeholder", "removeBtn"]

    connect() {
        this.updateVisibility()
    }

    readURL() {
        const input = this.inputTarget
        if (input.files && input.files[0]) {
            const reader = new FileReader()

            reader.onload = (e) => {
                this.previewTarget.style.backgroundImage = `url('${e.target.result}')`
                this.updateVisibility(true)
            }

            reader.readAsDataURL(input.files[0])
        }
    }

    remove() {
        this.inputTarget.value = ''
        this.previewTarget.style.backgroundImage = 'none'
        this.updateVisibility(false)
    }

    updateVisibility(hasImage = false) {
        // Check if there is an existing image (for edit mode)
        const bgImage = this.previewTarget.style.backgroundImage
        const hasExistingImage = bgImage &&
            bgImage !== 'none' &&
            bgImage.includes('url') &&
            !bgImage.includes('url("")') &&
            !bgImage.includes("url('')")

        const visible = hasImage || hasExistingImage

        if (visible) {
            this.previewTarget.classList.remove("hidden")
            if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add("hidden")
            if (this.hasRemoveBtnTarget) this.removeBtnTarget.classList.remove("hidden")
        } else {
            this.previewTarget.classList.add("hidden")
            if (this.hasPlaceholderTarget) this.placeholderTarget.classList.remove("hidden")
            if (this.hasRemoveBtnTarget) this.removeBtnTarget.classList.add("hidden")
        }
    }
}
